import { WithdrawalsExchangeRatesRecord } from '@types';

import { WithdrawalsSetExchangeRatesCurrencyReducer } from './types';

export const withdrawalsSetExchangeRatesCurrencyReducer: WithdrawalsSetExchangeRatesCurrencyReducer =
  (state, action) => {
    const { exchangeRateId, currency } = action.payload;

    const exchangeRateToUpdate =
      state.withdrawalsExchangeRatesProcessedItems?.[exchangeRateId];

    if (!exchangeRateToUpdate) {
      return state;
    }

    const updatedItem: WithdrawalsExchangeRatesRecord = {
      [exchangeRateId]: {
        ...exchangeRateToUpdate,
        currency,
      },
    };

    return {
      ...state,
      withdrawalsExchangeRatesProcessedItems: {
        ...state.withdrawalsExchangeRatesProcessedItems,
        ...updatedItem,
      },
    };
  };
